var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGlobe = function SvgIconGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M8 15.167A6.667 6.667 0 1 0 8 1.833a6.667 6.667 0 0 0 0 13.334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M4 3.64c.52.474 1.592 1.769 1.717 3.158.116 1.3.973 2.355 2.283 2.368.503.006 1.012-.357 1.01-.86a1.8 1.8 0 0 0-.065-.462A.93.93 0 0 1 9 7.166c.407-.838 1.207-1.063 1.84-1.518.28-.202.537-.415.65-.587.313-.473.625-1.42.469-1.894m2.708 6c-.22.62-.375 2.25-2.855 2.276 0 0-2.195 0-2.854 1.24-.527.994-.22 2.07 0 2.483"
  })));
};
export default SvgIconGlobe;